module.exports = __webpack_public_path__ + "static/media/PORTADA_CICLO_3_TECNOLÓGICO.0361eef5.jpg";